<template>
    <div :class="{
        'my-2': !IsPembayaran,
        'mx-4': !IsPembayaran
    }">
        <div class="row">
            <div class="col-12 mb-2" v-if="!IsPembayaran">
                <hr>
            </div>

            <div class="col-12">
                <div class="row mb-2" v-for="(Letter, IndexLetter) in  ListOfLetters " :key="IndexLetter">
                    <div class="col-1 d-flex align-items-center" v-if="!IsPembayaran">
                        {{ IndexLetter + 1 }}.
                    </div>
                    <div :class="['col-' + (IsPembayaran ? '12' : '11')]">
                        <div class="alert alert-primary mb-0 p-4" :class="{ 'payment-settled': IsPaymentSettled }">
                            <div class="row">
                                <div class="col-8 d-flex align-items-center justify-content-start">
                                    <strong>{{ Letter.NamaSurat }}</strong> <template v-if="!IsPembayaran"> <span
                                            class="ml-1">
                                            -
                                            {{ Letter.NamaPasien }}/{{ Letter.UmurPasien }}/{{ Letter.JenisKelamin }}</span>
                                    </template>
                                </div>
                                <div class="col-4 d-flex align-items-center justify-content-end">
                                    <template v-if="IsPaymentSettled">
                                        <span class="d-flex align-items-center">
                                            Actions
                                            <font-awesome-icon icon="chevron-down" class="ml-2 font-size-md" />
                                        </span>
                                    </template>
                                    <template v-else>
                                        <b-button-group>
                                            <b-dropdown dropleft text="Actions" variant="success" class="custom-dropdown" no-caret>
                                                <template v-if="IsPembayaran">
                                                    <b-dropdown-item class="text-capitalize"
                                                        @click="EditLetter(Letter.SuratID, Letter.TableName)">
                                                        edit
                                                    </b-dropdown-item>
                                                </template>
                                                <b-dropdown-item class="text-capitalize"
                                                    @click="DownloadLetter(Letter)">
                                                    download
                                                </b-dropdown-item>
                                                <b-dropdown-item class="text-capitalize"
                                                    @click="PrintLetter(Letter.PDFBase64)">
                                                    cetak
                                                </b-dropdown-item>
                                                <b-dropdown-item class="text-capitalize"
                                                    @click="DeleteLetter(Letter.SuratID, Letter.TableName)">
                                                    hapus
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </b-button-group>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { LetterMap } from '../Helpers/LetterMap'
import { ParseJenisKelaminSurat } from '../Helpers/ParseJenisKelaminSurat';

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronDown);


export default {
    name: 'SuratPenunjangList',
    components: {
        "font-awesome-icon": FontAwesomeIcon
    },
    props: {
        IsPembayaran: {
            type: Boolean,
            default: false
        },
        IsPaymentSettled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ListOfLetters: []
        }
    },
    watch: {
        TransKlinikIDFromPembayaran: {
            handler(val) {
                if (val) {
                    this.$nextTick(async () => {
                        await this.GetListOfLetter()
                    })
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapState('SuratPenunjangStore', ['TransKlinikIDFromPembayaran']),
        ...mapGetters('SuratPenunjangStore', ['API_URL', 'TransKlinikID']),
        DaftarSuratEndpoint() {
            return `${this.API_URL}/daftar-surat`
        }
    },
    mounted() {
        if (!this.IsPembayaran) {
            this.$nextTick(async () => {
                await this.GetListOfLetter()
            })
        }
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetCurrentlyPrintingLetterMutation', 'SetLetterMutation', 'SetLetterTypeMutation', 'SetLetterID']),
        async GetListOfLetter() {
            this.SET_LOADING(true)

            const ID = !this.IsPembayaran ? this.TransKlinikID : this.TransKlinikIDFromPembayaran
            const { data } = await this.$axios.get(`${this.DaftarSuratEndpoint}/${ID}`);

            if (data.length > 0) {
                this.ListOfLetters = data.map(item => {
                    return {
                        SuratID: item.id,
                        TableName: item.table_name,
                        NamaPasien: item.nama_pasien.trim(),
                        UmurPasien: item.umur_pasien,
                        JenisKelamin: ParseJenisKelaminSurat(item.jenis_kelamin_pasien),
                        NamaSurat: LetterMap(item.table_name),
                        PDFBase64: item.pdf_base64
                    }
                })
            } else {
                this.ListOfLetters = []
            }

            this.SET_LOADING(false)

            return true
        },
        ProxyAddLetter(LetterType) {
            this.SetLetterTypeMutation(LetterType)
            this.SetLetterMutation(true)
        },
        EditLetter(LetterID, TableName) {
            const LetterType = LetterMap(TableName)

            this.SetLetterID(LetterID)
            this.ProxyAddLetter(LetterType)
        },
        async DeleteLetter(LetterID, TableName) {
            await this.$axios.delete(`${this.DaftarSuratEndpoint}/${LetterID}/${TableName}`);

            await this.GetListOfLetter();
        },
        async PrintLetter(PDFBase64) {
            this.SET_LOADING(true)

            const TmpPDFBlob = await fetch(PDFBase64).then(res => res.blob());

            const PDFBlob = URL.createObjectURL(TmpPDFBlob);

            const TargetIframePDF = document.querySelector('#LetterIframe')

            if (TargetIframePDF) {
                document.body.removeChild(TargetIframePDF);
            }

            // Create a new iframe
            let iframe = document.createElement('iframe');

            // Set iframe attributes
            iframe.setAttribute('style', 'position:absolute;right:0; top:0; bottom:0; height:100%; width:500px; padding:20px; z-index:-9999;');
            iframe.setAttribute('id', 'LetterIframe')
            iframe.src = PDFBlob;

            // Append iframe to body
            document.body.appendChild(iframe);

            // Wait for iframe to load
            iframe.onload = () => {
                setTimeout(() => {
                    // After iframe has completely loaded, print
                    iframe.contentWindow.print();

                    URL.revokeObjectURL(PDFBlob);

                    this.SET_LOADING(false)
                }, 1000);
            }
        },
        async DownloadLetter(data) {
            this.SET_LOADING(true)

            const TmpPDFBlob = await fetch(data.PDFBase64).then(res => res.blob());

            const PDFBlob = URL.createObjectURL(TmpPDFBlob);

            const link = document.createElement('a');
            link.href = PDFBlob;
            link.download = `${data.TableName}_${data.NamaPasien}.pdf`;
            link.click();

            this.SET_LOADING(false)
        }
    }
}
</script>

<style>
.custom-dropdown ul > li > a.dropdown-item {
    padding: 0.35rem 1rem !important;
}
.custom-dropdown .dropdown-toggle::before {
  display: none;
}
</style>

<style scoped>
.payment-settled {
    background-color: #eee !important;
    cursor: not-allowed;
}

.alert-primary {
    background-color: #e7f3ff;
    border-color: #e7f3ff;
}
</style>